/* eslint-disable */
import React from "react";
import {
  Box,
  SimpleGrid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
} from "recharts";

export default function TicketCharts({ stats }) {
  const textColor = useColorModeValue("secondaryGray.900", "white");

  const statusData = Object.entries(stats?.status_summary || {}).map(
    ([name, value]) => ({
      name,
      value,
    })
  );

  const urgencyData = Object.entries(stats?.urgency_summary || {}).map(
    ([name, value]) => ({
      name,
      value,
    })
  );

  const categoryData = Object.entries(stats?.category_summary || {}).map(
    ([name, value]) => ({
      name,
      value,
    })
  );

  const COLORS = ["#4318FF", "#6AD2FF", "#FFB547", "#05CD99", "#EE5D50"];

  return (
    <SimpleGrid columns={{ base: 1, xl: 3 }} spacing="20px" mb="20px">
      <Card p="20px">
        <Text fontSize="20px" fontWeight="800" color={textColor} mb="15px">
          Status Ticket
        </Text>

        <Box h="260px">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={statusData}
                dataKey="value"
                nameKey="name"
                outerRadius={90}
                label
              >
                {statusData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </Card>

      <Card p="20px">
        <Text fontSize="20px" fontWeight="800" color={textColor} mb="15px">
          Urgensi Ticket
        </Text>

        <Box h="260px">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={urgencyData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="value" radius={[10, 10, 0, 0]} fill="#4318FF" />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Card>

      <Card p="20px">
        <Text fontSize="20px" fontWeight="800" color={textColor} mb="15px">
          Kategori Ticket
        </Text>

        <Box h="260px">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={categoryData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="value" radius={[10, 10, 0, 0]} fill="#05CD99" />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Card>
    </SimpleGrid>
  );
}